import bootstrap from './webparts';
import './index.scss';

(w => {
    if (w.document.readyState === 'complete' || w.document.readyState !== 'loading' && !w.document.documentElement.doScroll) {
        w.setTimeout(() => bootstrap(w.document.body));
    } else {
        w.document.addEventListener('DOMContentLoaded', () => bootstrap(w.document.body));
    }
})(window);


// WEBPACK FOOTER //
// ./src/nams2020/index.js